import { Link } from 'react-router-dom'
const OrderItem = ({ order }) => {
    // const renderOrderItems = order.items.map(x => {
    //     return (
    //         <div className="event" key={x.service.id}>
    //             <div className="summary">
    //                 {x.service.name}
    //             </div>
    //         </div>
    //     )
    // })
    return (
        <div className='ui card fluid' style={{position: 'relative', overflow: 'hidden'}}>
            <div className={`payment-status ${order.paid ? "paid" : "unpaid"}`}>{order.paid ? "Paid" : "Unpaid"}</div>
            <div className="content">
                <h4 className="ui sub header">ID: {order.receipt}</h4>
                <div className="meta">
                    {/* <span className="date">&#8377;{order.total}</span> */}
                    <span>Fullfill by : {order.fullfill_by}</span>
                </div>
                <h4 className="ui sub header">Order Details</h4>
                <div className="ui small feed">
                    <div className="event">
                        <div className="summary">
                            Coupon Applied : {order?.coupon?.code ? order.coupon.code : "No Coupon Applied"}
                        </div>
                    </div>
                    <div className="event">
                        <div className="summary">
                            Discount Percent : {order?.coupon?.discount ? order.coupon?.discount + "%" : "0%"}
                        </div>
                    </div>
                    <div className="event">
                        <div className="summary">
                            Total : &#8377;{order.total}
                        </div>
                    </div>
                </div>
            </div>
            <div className="extra content">
                <Link className="ui button secondary" to={`order/${order.receipt}`}>View Order</Link>
            </div>
        </div>
    )
}

export default OrderItem